module.exports = __webpack_public_path__ + "static/media/19ESCAP51.ff096ce6.jpg";